<div class="small-box bg-info {{bodyCssClass}}">
    <div class="inner">
        <h3>{{counter}}</h3>
        <p>{{description}}</p>
    </div>
    <div class="icon">
        <span class="material-icons">
            {{icon}}
        </span>
    </div>
    <a [routerLink]="[detailUrl]" class="small-box-footer {{footerCssClass}}">
        Plus de détails <i class="fas fa-arrow-circle-right"></i>
    </a>
</div>